import {IOptionItemChoice, IUserSelection} from "@bimaire/optionslib";

function selectionToString(selection: IOptionItemChoice) {
  return selection.choice.items.map(itm => itm.item.id).join("!");
}

function formatOutput(output: string, matchResults: RegExpMatchArray) {
  const digitRegexp = /\$\d+/g;

  let retval = output;
  const hits = Array.from(output.matchAll(digitRegexp));

  for (const hit of hits) {
    const matchString = hit[0];
    const matchIndex = parseInt(matchString.substring(1));
    if (matchResults.length < matchIndex) {
      throw new Error(
        `Output template is incorrect - attempted to access match with ${matchString}, but there are only ${matchResults.length} groups in template ${output}`
      );
    }
    retval = retval.replace(matchString, matchResults[matchIndex]);
  }
  return retval;
}

class UnrealOptionTransformation {
  constructor(
    private readonly pattern: RegExp,
    private readonly output: string
  ) {}

  static fromConfigString(config: string) {
    const parts = config.split("=>");
    if (parts.length != 2)
      throw new Error(
        `Invalid config string - missing => delimiter: ${config}`
      );
    return new UnrealOptionTransformation(
      new RegExp(parts[0].trim()),
      parts[1].trim()
    );
  }

  processSelection(selection: IOptionItemChoice) {
    const selectionString = selectionToString(selection);

    const matchResult = selectionString.match(this.pattern);
    if (matchResult === null) return null;
    return formatOutput(this.output, matchResult);
  }
}
export default UnrealOptionTransformation;
